/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qk_IsInputs */

const en_qk_is = /** @type {(inputs: Qk_IsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`open, closed, blocked, mine, unassigned`)
};

const de_qk_is = /** @type {(inputs: Qk_IsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`open, closed, blocked, mine, unassigned`)
};

/**
* | output |
* | --- |
* | "open, closed, blocked, mine, unassigned" |
*
* @param {Qk_IsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const qk_is = /** @type {((inputs?: Qk_IsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qk_IsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_qk_is(inputs)
	return en_qk_is(inputs)
});